// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title{padding:0 2em;text-align:center;margin-bottom:2em}", "",{"version":3,"sources":["webpack://./pages/EmailUnsubscribe/styles.scss"],"names":[],"mappings":"AAAA,OACI,aAAA,CACA,iBAAA,CACA,iBAAA","sourcesContent":[".title {\n    padding: 0 2em;\n    text-align: center;\n    margin-bottom: 2em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
